import type { CityConfig } from "@/pages/city-template/types";

export const syracuseConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Syracuse",
  state: "New York",
  stateAbbr: "NY",
  slug: "syracuse",
  route: "/cities/syracuse",
  title: "Emergency Passport Syracuse, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Syracuse, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Syracuse University students, Lockheed Martin engineers, Upstate Medical professionals, and Central New York families.",
  h1: "Emergency & Expedited Passport Services in Syracuse, NY",
  heroSubtitle: "SU spring break trip to Punta Cana and your passport is expired? Lockheed Martin supplier meeting in London in 5 days? Upstate Medical conference in Geneva next week? We help Syracuse residents — from University Hill to Liverpool to Fayetteville — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20downtown%20Syracuse%20New%20York%20skyline%20at%20golden%20hour%20with%20the%20iconic%20Carrier%20Dome%20stadium%20and%20modern%20university%20buildings%2C%20autumn%20foliage%20colors%20in%20the%20foreground%2C%20dramatic%20sunset%20clouds%20reflecting%20warm%20amber%20and%20golden%20light%2C%20clean%20urban%20landscape%20with%20Onondaga%20Lake%20in%20the%20distance%2C%20professional%20architectural%20photography%20with%20rich%20warm%20tones%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=syracuse-hero-2026-v2&orientation=landscape",
  heroImageAlt: "Syracuse New York skyline with Carrier Dome and university buildings at golden hour",
  geoPosition: "43.0481;-76.1474",
  geoPlacename: "Syracuse, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Buffalo Passport Agency",
    address: "111 Genesee Street Suite 101, Buffalo, NY 14203",
    distance: "~150 miles from Syracuse — our courier eliminates the need to drive to Buffalo",
  },
  nearbyCitiesZips: [
    { name: "Syracuse", zips: "13201–13210, 13211, 13212, 13214, 13215, 13217–13220, 13224, 13225, 13235, 13244, 13250–13252, 13261, 13290" },
    { name: "Liverpool", zips: "13088, 13089, 13090" },
    { name: "DeWitt", zips: "13214, 13224" },
    { name: "Fayetteville", zips: "13066" },
    { name: "Manlius", zips: "13104" },
    { name: "Clay", zips: "13041, 13090" },
    { name: "Cicero", zips: "13029, 13039, 13041" },
    { name: "Camillus", zips: "13031, 13219" },
    { name: "Baldwinsville", zips: "13027" },
    { name: "Oswego", zips: "13126" },
    { name: "Utica", zips: "13501–13505, 13599" },
    { name: "Rome", zips: "13440–13442, 13449" },
    { name: "Auburn", zips: "13021" },
    { name: "Skaneateles", zips: "13152" },
    { name: "Cazenovia", zips: "13035" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Buffalo Passport Agency — as fast as 24 hours for Syracuse-area travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "Syracuse Hancock Airport Expertise", desc: "SYR connects to all major U.S. hubs. We know airline schedules, winter weather delays, and connecting flight timing for international itineraries." },
    { icon: "ri-graduation-cap-line", title: "Syracuse University & College Ready", desc: "SU, SUNY ESF, Upstate Medical, Le Moyne — we guide students and faculty through study abroad, conference, and research passport timelines." },
    { icon: "ri-snowy-line", title: "Winter Escape Season Specialists", desc: "Syracuse averages 120+ inches of snow annually. We handle the predictable January–March rush of snowbirds fleeing to Florida and the Caribbean." },
  ],
  internalLinks: [
    { name: "Fast passport services in New York City", route: "/cities/new-york-city" },
    { name: "Expedited passport in Buffalo, NY", route: "/cities/buffalo" },
    { name: "Quick passport services in Albany, NY", route: "/cities/albany-ny" },
    { name: "Urgent passport services in Rochester", route: "/cities/rochester" },
    { name: "New York State passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Syracuse via secure registered courier with direct access to the Buffalo Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 150-mile drive to Buffalo. Syracuse residents can ship from any UPS Store, FedEx Office, or post office location across Onondaga County.",
  fpcOfficeDistance: "Serving Syracuse, Liverpool, DeWitt, Fayetteville, and all Central New York communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Syracuse and all of Central New York. From University Hill and downtown Syracuse to the northern suburbs of Liverpool and Clay, from the eastern communities of DeWitt and Fayetteville to the Finger Lakes towns of Skaneateles and Auburn — we serve all of Onondaga County and beyond. Our courier service eliminates the need to drive 150 miles to the Buffalo Passport Agency in downtown Buffalo.",
  nearbyCitiesIntro: "We serve Syracuse and all Central New York communities including Liverpool, DeWitt, Fayetteville, Manlius, Clay, Cicero, Camillus, Baldwinsville, Oswego, Utica, Rome, Auburn, Skaneateles, and Cazenovia. We also serve travelers departing from Syracuse Hancock International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Syracuse as simple as possible — with the efficiency and reliability SU students, Central New York professionals, and Finger Lakes families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Syracuse travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Syracuse travelers encounter unique passport issues — everything from SU study abroad deadlines to winter escape passport emergencies. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Syracuse travelers — from SU students to Lockheed Martin engineers to Central New York snowbirds — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Syracuse, NY? Here are the most common ones we hear from Central New York travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a SYR-to-Atlanta connection to Europe, an emergency passport for a last-minute Caribbean escape, or a first-time passport for an SU student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingIntro: "Syracuse travelers — SU students studying abroad, Upstate Medical professionals heading to international conferences, Lockheed Martin engineers on supplier visits, and Central New York families escaping winter for the Caribbean — have several options for getting a passport fast. Here is how they compare, and why most Central New York residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the 150-mile drive to the Buffalo Passport Agency.",
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission — no 250-mile drive needed", "Ideal for SU students studying abroad in Europe or Asia", "Perfect for Upstate Medical professionals at international conferences", "Great for Central NY families flying SYR to Punta Cana or Cancun", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service at Syracuse post offices", "Good for planned international trips from SYR", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required at Onondaga County facilities", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required at Buffalo Passport Agency — 150 miles away in downtown Buffalo", "No walk-ins accepted at any regional agency", "Life-or-death emergencies only — bereavement or medical crisis", "Must prove travel within 72 hours with printed itinerary", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Winter escape flight to Punta Cana in 3 days? Lockheed Martin meeting in London this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Syracuse-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Syracuse residents renew fast — no agency visit required for most renewals. Perfect for downtown professionals, SU faculty, and Central New York families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Syracuse residents through every step — from University Hill to Liverpool to Fayetteville — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your winter escape or SU spring break trip stays on schedule.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Central New York family vacation to the Caribbean stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Syracuse professionals after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Lockheed Martin engineers, SU faculty researchers, and Syracuse corporate travelers who need a backup while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Central New York travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Central New Yorkers visiting Montreal and Toronto.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Syracuse NY", description: "Urgent passport processing for Syracuse New York travelers with immediate departure needs from SYR Airport." },
    { name: "Expedited Passport Renewal Syracuse NY", description: "Fast passport renewal for Syracuse New York residents with a previously-issued passport." },
    { name: "First-Time Passport Syracuse NY", description: "New passport application services for Syracuse New York residents applying for their first passport." },
    { name: "Child Passport Syracuse NY", description: "Minor passport services for Syracuse New York families with children under 16." },
    { name: "Name Change Passport Syracuse NY", description: "Passport name correction after marriage, divorce, or legal name changes for Syracuse residents." },
    { name: "Second Passport Syracuse NY", description: "Second passport services for Syracuse defense industry professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Liverpool",
      rating: 5,
      text: "Had a family emergency in Ireland and needed my passport in 3 days. Fast Passport Center delivered exactly on time. Their Syracuse team was incredibly responsive and kept me updated every step.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda K.",
      location: "University Hill, Syracuse",
      rating: 5,
      text: "SU grad student here — got accepted to a summer program in Barcelona with 3 weeks notice. First passport ever. They guided me through the DS-11 at the downtown post office and the passport arrived in 5 days. Absolute lifesaver.",
      service: "New Passport",
    },
    {
      name: "David L.",
      location: "Fayetteville",
      rating: 5,
      text: "Lockheed Martin sent me to a supplier audit in the UK with one week notice. Fast Passport Center got my renewal back in 48 hours. The document review caught a photo issue I would have missed.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah K.",
      location: "DeWitt",
      rating: 5,
      text: "We booked a winter escape to Jamaica and realized both our kids' passports expired. They walked us through the child passport process and all four passports arrived in 5 days. Made our flight with time to spare.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "syr-1",
      name: "Syracuse Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5640 E Taft Rd",
      city: "Syracuse",
      state: "NY",
      zip: "13220",
      phone: "(315) 452-3350",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "North Syracuse",
      website: "https://tools.usps.com/find-location.htm?location=1367618",
      websiteLabel: "USPS Location",
      notes: "Syracuse's primary passport acceptance facility. Photo services on-site. Busiest facility in Onondaga County — book appointments 2+ weeks ahead during winter escape season.",
      icon: "ri-mail-line",
    },
    {
      id: "syr-2",
      name: "Downtown Syracuse Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "444 S Salina St",
      city: "Syracuse",
      state: "NY",
      zip: "13202",
      phone: "(315) 476-8201",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Downtown Syracuse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for downtown workers, SU students, and University Hill residents. Limited hours — no weekend availability. Passport photos not available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "syr-3",
      name: "Liverpool Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7341 Oswego Rd",
      city: "Liverpool",
      state: "NY",
      zip: "13090",
      phone: "(315) 622-0471",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Liverpool — North Suburbs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Liverpool, Clay, and Cicero. Passport photos available. Saturday appointments fill quickly during winter months.",
      icon: "ri-mail-line",
    },
    {
      id: "syr-4",
      name: "DeWitt Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4725 E Genesee St",
      city: "DeWitt",
      state: "NY",
      zip: "13214",
      phone: "(315) 446-0300",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "DeWitt — East Suburbs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves DeWitt, Fayetteville, and Manlius. Popular with SU faculty and Le Moyne College students. Passport photos on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "syr-5",
      name: "Onondaga County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "401 Montgomery St, Room 200",
      city: "Syracuse",
      state: "NY",
      zip: "13202",
      phone: "(315) 435-2221",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Downtown Syracuse — County Courthouse",
      website: "https://www.ongov.net/clerk/",
      websiteLabel: "Onondaga County Clerk",
      notes: "County-operated acceptance facility. Also handles marriage license records for name change documentation. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "syr-6",
      name: "Camillus Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "121 W Genesee St",
      city: "Camillus",
      state: "NY",
      zip: "13031",
      phone: "(315) 672-8643",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Camillus — West Suburbs",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Western Onondaga County option for Camillus, Fairmount, and Geddes residents. Limited walk-in availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out at NYC agency, 250 miles away", fpc: "No appointment needed to start — ship from home" },
    { feature: "In-Person Visit", agency: "Required — drive to the Buffalo Passport Agency in downtown Buffalo", fpc: "Most Syracuse travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel within 72 hours", fpc: "As fast as 24 hours — multiple speed options available" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay of 2+ weeks", fpc: "Professional review to catch photo issues, form errors, and missing signatures" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only on tight eligibility", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee of service", fpc: "Predictable processing based on selected speed option with guaranteed turnaround" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation, no travel proof needed" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle 250-mile drive and all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Syracuse-Specific Guidance", agency: "Generic — no SU, winter escape, or Central NY expertise", fpc: "Full SU/university/snowbird/Central NY knowledge built into our service" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Waiting Until January to Check Passport for Winter Escape",
      description: "Syracuse's brutal winters (120+ inches annually) drive a massive seasonal exodus. But many snowbirds wait until January to check passports — only to discover they expired in the fall. By then, every expedited service is slammed. Check your passport in October.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Syracuse applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many Syracuse-area CVS and Walgreens locations produce photos that fail State Department standards — wrong background shade, incorrect head size, or shadows. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Central New York families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection for child passports — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Connecting Flight Passport Requirements",
      description: "SYR is a spoke airport — all international travel connects through hubs. Syracuse travelers sometimes assume domestic connections do not require a passport, but airlines verify passport validity at SYR check-in for any international itinerary.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or SU dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Syracuse clients ship from home or a nearby UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 250 miles to Manhattan or wait for a post office appointment." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Syracuse?", a: "We offer Syracuse-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays — especially important during Syracuse's winter escape season when every expedited service is slammed." },
    { q: "Do I need to visit a Syracuse office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (a Syracuse-area post office or the Onondaga County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Syracuse address." },
    { q: "Where can I get passport acceptance in Syracuse?", a: "Syracuse has acceptance facilities at the Main Post Office on Taft Road, the Downtown Post Office on Salina Street, Liverpool Post Office on Oswego Road, DeWitt Post Office on East Genesee Street, and the Onondaga County Clerk at the County Courthouse. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "Does the Buffalo Passport Agency serve Syracuse walk-ins?", a: "The Buffalo Passport Agency (111 Genesee Street Suite 101, downtown Buffalo, 150 miles from Syracuse) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without the 4+ hour drive." },
    { q: "What is the best price for expedited passport service in Syracuse?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can you help SU students with study abroad passports?", a: "Yes. Syracuse University sends thousands of students abroad annually through programs in London, Florence, Madrid, Strasbourg, and beyond. Many SU students — especially international students studying in the U.S. — have complex passport situations. We guide SU students through the entire process." },
    { q: "Can I get a passport photo in Syracuse?", a: "Yes — many Syracuse-area CVS, Walgreens, UPS Stores, and FedEx Office locations offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does Syracuse's winter affect passport processing?", a: "Syracuse averages 120+ inches of snow annually, creating a predictable January–March rush of snowbirds seeking expedited passports for Caribbean and Florida escapes. We recommend checking your passport in October — before the winter rush — to avoid competing with thousands of other Central New Yorkers who all discover expired passports at the same time." },
    { q: "What about SYR Airport international connections?", a: "Syracuse Hancock International Airport connects to Atlanta, Charlotte, Chicago, Detroit, and New York hubs, providing one-stop international access worldwide. Airlines verify passport validity at SYR check-in for any international itinerary — even if your first flight is domestic." },
    { q: "Can you help with Lockheed Martin and defense industry passport needs?", a: "Yes. Central New York's defense and manufacturing sector — including Lockheed Martin, Saab, and Welch Allyn — sends engineers and executives abroad for supplier visits and international programs. We understand the urgency of defense industry travel and can expedite passports in as little as 24 hours." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Syracuse Residents",
    intro: "Syracuse's position as Central New York's hub — with a major university, defense industry, and legendary winters — creates distinct passport timing challenges. Here's what Syracuse travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SYR — Syracuse Hancock International Airport",
        subtitle: "Central New York's primary airport, hub connections to global destinations",
        description: "Syracuse Hancock International Airport connects Central New York to Atlanta, Charlotte, Chicago, Detroit, New York-JFK, and Washington-Dulles, providing one-stop access to virtually every international destination. SYR handles 2M+ passengers annually. The spoke-to-hub model means Syracuse travelers must have valid passports at SYR check-in — airlines verify documents for the entire international itinerary, not just the first domestic leg.",
        tip: "SYR's early morning flights connect to afternoon international departures at hubs. If your passport is flagged at SYR check-in, you miss your connection. Always check passport validity at least 3 weeks before any international itinerary from SYR.",
      },
      {
        icon: "ri-snowy-line",
        title: "Syracuse Winter Escape Season — The January Rush",
        subtitle: "120+ inches of snow drives massive seasonal migration",
        description: "Syracuse is one of the snowiest cities in America, and its residents flee in droves. From January through March, thousands of Central New Yorkers book last-minute trips to Florida, the Caribbean, and Mexico. This creates a predictable and intense passport rush every winter — families discover expired passports while packing, couples realize their documents expired during the fall, and snowbirds find their passport has less than 6 months of validity. Every expedited service in the region gets slammed simultaneously.",
        tip: "If you live in Syracuse and even suspect you will book a winter escape, check your passport in October. The January passport rush is real and predictable — do not be one of the hundreds of Central New York families scrambling the same week.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "Syracuse University & College Study Abroad",
        subtitle: "SU, SUNY ESF, Upstate Medical, Le Moyne College",
        description: "Syracuse University alone has over 22,000 students with study abroad programs in 60+ countries — including flagship centers in London, Florence, Madrid, and Strasbourg. SUNY ESF sends environmental science students to field programs worldwide. Upstate Medical University faculty travel to international conferences and research collaborations. The combined student and academic population creates a massive, recurring passport demand with hard deadlines tied to academic calendars.",
        tip: "SU study abroad acceptance letters arrive 8–10 weeks before departure. International students at SU have additional complexity — they may need to renew passports from their home countries while studying in Syracuse. Start the passport process the same week you receive your acceptance.",
      },
      {
        icon: "ri-building-2-line",
        title: "Defense & Manufacturing Industry Travel",
        subtitle: "Lockheed Martin, Saab, Welch Allyn, SRC Inc.",
        description: "Central New York's defense and advanced manufacturing sector sends engineers, program managers, and executives abroad regularly. Lockheed Martin's Salina facility supports international radar and electronic warfare programs. Saab's Syracuse operation handles global defense contracts. Welch Allyn (now Baxter) sends medical device teams to Asia and Europe. These trips often materialize on short notice — supplier audits, program reviews, and site inspections with 5–10 days of lead time.",
        tip: "Defense industry travel to the UK, Germany, Japan, and Korea almost always triggers the 6-month passport validity rule. If you work in defense manufacturing in Syracuse, keep your passport renewed proactively — do not wait for a trip to be announced.",
      },
    ],
    callout: {
      icon: "ri-train-line",
      title: "Finger Lakes Tourism & Seasonal Travel Patterns",
      description: "Syracuse serves as the gateway to the Finger Lakes region, and many Central New York residents work in the tourism and wine industry. International visitors to Finger Lakes wineries and summer festivals create inbound passport demand, while tourism industry professionals attending international wine and hospitality conferences create outbound demand — especially during the spring and fall shoulder seasons.",
    },
  },
  destinations: {
    title: "Where Syracuse Travelers Go — And Why Passports Get Urgent",
    intro: "Syracuse's university, defense industry, and winter escape culture shape where Central New Yorkers travel. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "41%", label: "of Syracuse expedited requests are winter escape or spring break related with 2–3 weeks notice" },
      { stat: "2–4 Weeks", label: "average lead time from booking winter vacation package to SYR international departure" },
      { stat: "Jan–Mar", label: "peak snowbird season — 120+ inches of snow drives mass Caribbean and Florida bookings" },
      { stat: "33 Hours", label: "shortest turnaround for a Lockheed Martin engineer departing to the UK" },
    ],
    destinations: [
      { name: "Caribbean & Mexico", context: "SYR-ATL-Punta Cana and SYR-CLT-Cancun connections, all-inclusive resort packages, spring break for SU and Le Moyne students", urgency: "Winter escape bookings spike December–January as the snow piles up; many families discover expired passports while packing", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SU London center is one of the largest U.S. study abroad programs in the UK, Lockheed Martin UK supplier relationships, strong Irish heritage in Syracuse", urgency: "SU academic calendar dictates fixed program dates; defense industry travel booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "SU Florence center, SU Strasbourg program, Finger Lakes wine industry exchange programs with European wine regions", urgency: "Study abroad acceptance-to-departure is 8 weeks; first-time passports needed for many students", icon: "ri-map-pin-2-line" },
      { name: "Dominican Republic", context: "Growing Dominican community in Syracuse, SYR-ATL-PUJ connections, family reunions in Santo Domingo and Santiago", urgency: "Multi-generational family trips with 3–6 week planning windows and multiple passport renewals needed simultaneously", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "Lockheed Martin and Saab European supplier relationships, SU study abroad, medical device conferences for Baxter/Welch Allyn", urgency: "Defense industry and medical device travel booked on short notice with fixed conference or audit dates", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal weekend trips (4 hours), Toronto visits, Ottawa tourism, cross-border family connections in Ontario and Quebec", urgency: "Spontaneous weekend trips — enhanced licenses work for land but not air travel to Canada", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "New York City", route: "/cities/new-york-city" },
      { name: "Buffalo", route: "/cities/buffalo" },
      { name: "Albany", route: "/cities/albany-ny" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Marshall Street", address: "700 S Crouse Ave, Syracuse, NY 13210", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Erie Blvd", address: "2600 Erie Blvd E, Syracuse, NY 13224", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Syracuse University Area", address: "721 University Ave, Syracuse, NY 13210", hours: "Mon–Fri 7 AM – 9 PM, Sat 8 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "UPS Store — Destiny USA Area", address: "9763 Carousel Center, Syracuse, NY 13290", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Liverpool", address: "430 Electronics Pkwy, Liverpool, NY 13088", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — DeWitt", address: "4405 E Genesee St, DeWitt, NY 13214", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Fayetteville", address: "103 N Peterboro St, Fayetteville, NY 13066", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Photo Center — Camillus", address: "1818 W Genesee St, Syracuse, NY 13204", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Syracuse (Erie Blvd)",
      address: "3530 Erie Blvd E, Syracuse, NY 13214",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Syracuse's busiest DMV. REAL ID, driver's license renewals, and enhanced licenses available. Appointment strongly recommended — walk-in wait times can exceed 2 hours.",
      featured: true,
    },
    {
      name: "NYS DMV — Liverpool",
      address: "7500 Oswego Rd, Liverpool, NY 13090",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Northern suburbs DMV serving Liverpool, Clay, and Cicero. REAL ID processing available.",
      featured: false,
    },
    {
      name: "NYS DMV — DeWitt",
      address: "4344 E Genesee St, DeWitt, NY 13214",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Eastern suburbs DMV serving DeWitt, Fayetteville, and Manlius. Convenient for SU faculty and Le Moyne students.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "7 miles north of downtown Syracuse",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Central New York's primary airport with direct flights to Atlanta, Charlotte, Chicago, Detroit, New York-JFK, and Washington-Dulles. One-stop connections to international destinations worldwide. Named after Syracuse native and astronaut Eileen Collins.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: true,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "80 miles from Syracuse",
      address: "1200 Brooks Ave, Rochester, NY 14624",
      note: "Alternative regional airport with domestic connections. Useful when SYR flights are fully booked during peak winter escape season.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport",
      featured: false,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "130 miles from Syracuse",
      address: "737 Albany Shaker Rd, Albany, NY 12211",
      note: "Capital Region airport with domestic hub connections. Eastern alternative for Syracuse travelers when SYR routes are limited.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health. Online, mail, or in-person options available for Onondaga County births.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYSDOH Vital Records. Required for estate and legal matters in Onondaga County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Onondaga County Clerk at 401 Montgomery Street. Certified copies for name changes and passport corrections.",
      url: "https://www.ongov.net/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Onondaga County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/5jd/onondaga/",
    },
  ],
};

export default syracuseConfig;